import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import CustomerIndex from "../../../components/SidetabPages/Customers/CustomerIndex";

const Customer = () => {
  return (
    <>
      <AnnouncementBar />
      <CustomerIndex />
    </>
  );
};
export default Customer;
